(function () {
  var STORAGE_KEY = 'mlp_home_notice_dismissed_on';
  var TZ = 'Asia/Kolkata';
  var SECTION_SELECTOR = '.section-sections--23698167824573__mlp_home_notice-padding';
  var SECTION_CLASS = 'mlp-home-notice-section-open';

  function todayIST() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }

  function istHour() {
    try {
      var h = parseInt(new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hour12: false, timeZone: TZ }).format(new Date()), 10);
      return h % 24;
    } catch (e) {
      var d = new Date();
      return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000).getHours();
    }
  }

  function getCfg() {
    try {
      var el = document.getElementById('mlp-config');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  }

  function setSectionOpen(isOpen) {
    var section = document.querySelector(SECTION_SELECTOR);
    if (section) section.classList.toggle(SECTION_CLASS, isOpen);
  }

  function init() {
    var box = document.querySelector('[data-mlp-home-notice]');
    if (!box) return;

    try {
      if (localStorage.getItem(STORAGE_KEY) === todayIST()) return;
    } catch (e) {}

    var cfg = getCfg();
    if (cfg) {
      var cutoff = parseInt(cfg.cutoffHour, 10);
      if (isNaN(cutoff)) cutoff = 19;
      var timingEl = box.querySelector('[data-mlp-home-notice-timing]');
      if (timingEl) {
        var message = istHour() < cutoff ? cfg.sameDayMessage : cfg.nextDayMessage;
        if (message) timingEl.textContent = message;
      }
    }

    box.hidden = false;
    setSectionOpen(true);

    var closeBtn = box.querySelector('[data-mlp-home-notice-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        box.hidden = true;
        setSectionOpen(false);
        try { localStorage.setItem(STORAGE_KEY, todayIST()); } catch (e) {}
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();